import React from 'react';
import MainLayout from '../layouts/MainLayout';
import DocxToPdfTester from 'components/documents/DocxToPdfTester';
import { useLanguage } from 'contexts/LanguageContext';

const DocxToPdfTest: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="container mx-auto px-4 py-8">
      <DocxToPdfTester />
    </div>
  );
};

export default DocxToPdfTest; 